import Navbar from '../../../components/Navbar';

export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Van Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/f6ce54d6c493569ba23f91de9ebbf942.png"
          alt="Beyond Electrical Van"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A1628]/90 via-[#0A1628]/75 to-[#0A1628]/85"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628] via-transparent to-[#0A1628]/60"></div>
      </div>

      {/* Subtle Energy Emoticons */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="energy-icon energy-1">⚡</div>
        <div className="energy-icon energy-2">⚡</div>
        <div className="energy-icon energy-3">⚡</div>
        <div className="energy-icon energy-4">⚡</div>
        <div className="energy-icon energy-5">⚡</div>
      </div>

      {/* Navigation */}
      <Navbar />

      {/* Hero Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20">
        <div className="animate-fade-in-up">

          {/* Location Badge */}
          <div className="inline-flex items-center gap-2 bg-[#FFD700]/20 border border-[#FFD700]/50 text-[#FFD700] px-4 py-1.5 rounded-full text-xs sm:text-sm font-semibold mb-6 backdrop-blur-sm">
            <i className="ri-map-pin-2-fill"></i>
            <span>Watford, Rickmansworth &amp; Surrounding Areas</span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-5 leading-tight">
            Your Local
            <span className="block text-[#FFD700] mt-1 glow-text">Electrical Experts Watford</span>
          </h1>

          <p className="text-base sm:text-xl md:text-2xl text-gray-200 mb-3 font-medium px-2">
            NICEIC Approved — Domestic &amp; Commercial
          </p>

          <p className="text-sm sm:text-base text-gray-300 mb-8 max-w-xl mx-auto leading-relaxed px-2">
            Trusted electricians covering <strong className="text-[#FFD700]">Watford</strong>, <strong className="text-[#FFD700]">Rickmansworth</strong>, Croxley Green, Chorleywood, Pinner, Northwood &amp; all surrounding areas.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center px-4">
            <a
              href="#contact"
              className="w-full sm:w-auto bg-[#FFD700] text-[#0A1628] px-7 py-3.5 rounded-full font-bold text-base hover:bg-[#FFC700] transition-all duration-300 shadow-xl hover:scale-105 whitespace-nowrap inline-flex items-center justify-center cursor-pointer"
            >
              <i className="ri-flashlight-line mr-2"></i>
              Get a Free Quote
            </a>
            <a
              href="tel:02031981818"
              className="w-full sm:w-auto bg-white/10 backdrop-blur-sm text-white px-7 py-3.5 rounded-full font-bold text-base hover:bg-white/20 transition-all duration-300 border-2 border-[#FFD700] whitespace-nowrap inline-flex items-center justify-center cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              020 3198 1818
            </a>
          </div>

          {/* Trust Badges */}
          <div className="mt-10 flex flex-wrap justify-center gap-3 px-2">
            {[
              { icon: 'ri-shield-check-fill', label: 'NICEIC Approved' },
              { icon: 'ri-award-fill', label: 'Fully Certified' },
              { icon: 'ri-map-pin-fill', label: 'Local Experts' },
              { icon: 'ri-time-fill', label: '15 Years Experience' },
            ].map((badge, i) => (
              <div key={i} className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-[#FFD700]/30 rounded-full px-3 py-1.5">
                <i className={`${badge.icon} text-[#FFD700] text-sm`}></i>
                <span className="text-white text-xs sm:text-sm font-medium whitespace-nowrap">{badge.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="mt-12 flex justify-center animate-bounce">
          <i className="ri-arrow-down-line text-[#FFD700] text-3xl"></i>
        </div>
      </div>

      {/* Mobile Floating Action Buttons */}
      <div className="fixed bottom-6 left-0 right-0 z-50 flex justify-between px-5 md:hidden pointer-events-none">
        {/* Call Now */}
        <a
          href="tel:02031981818"
          className="pointer-events-auto w-14 h-14 rounded-full bg-[#FFD700] flex items-center justify-center shadow-lg cursor-pointer"
          aria-label="Call Now"
          style={{ boxShadow: '0 0 16px 4px rgba(255,215,0,0.55)' }}
        >
          <span className="text-2xl">📞</span>
        </a>

        {/* WhatsApp */}
        <a
          href="https://wa.me/447989675952"
          target="_blank"
          rel="noopener noreferrer"
          className="pointer-events-auto w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg cursor-pointer"
          aria-label="WhatsApp"
          style={{ boxShadow: '0 0 16px 4px rgba(37,211,102,0.55)' }}
        >
          <span className="text-2xl">💬</span>
        </a>
      </div>

      <style>{`
        @keyframes subtle-flash {
          0%, 100% { opacity: 0.15; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.1); }
        }
        .energy-icon {
          position: absolute;
          font-size: 20px;
          color: #FFD700;
          animation: subtle-flash 3s ease-in-out infinite;
          text-shadow: 0 0 8px rgba(255, 215, 0, 0.4);
        }
        .energy-1 { left: 6%; top: 22%; animation-delay: 0s; animation-duration: 3s; }
        .energy-2 { left: 28%; top: 14%; animation-delay: 0.8s; animation-duration: 3.5s; }
        .energy-3 { right: 8%; top: 28%; animation-delay: 1.5s; animation-duration: 3.2s; }
        .energy-4 { right: 5%; bottom: 30%; animation-delay: 2s; animation-duration: 3.8s; }
        .energy-5 { left: 48%; bottom: 20%; animation-delay: 1s; animation-duration: 3.4s; }

        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up { animation: fade-in-up 1s ease-out; }

        .glow-text {
          text-shadow: 0 0 20px rgba(255,215,0,0.6), 0 0 40px rgba(255,215,0,0.3);
        }
      `}</style>
    </section>
  );
}